import OadpIframe from './oadp-iframe';
export default OadpIframe;
